import { useQuery } from "react-query";
import http from "infra/http";

function useCodigoImpostoAutoComplete() {
    return useQuery("/v1/imposto/codigos", async () => {
        const { data } = await http.get<{ codigo: string; nome: string }[]>(
            "/v1/imposto/codigos"
        );

        return data;
    });
}

export default useCodigoImpostoAutoComplete;
